import { icon } from "../lib/icons";

export function dispatchHTML(): string {
  return `
<div x-data="dispatch()">
  ${summaryHTML()}
  <div class="dispatch-grid">
    ${columnHTML("ramp", "On the ramp", "rampCards", "Nothing scheduled at the moment.")}
    ${columnHTML("airborne", "Active", "activeCards", "No flights active right now.")}
    ${columnHTML("closed", "Closed today", "closedCards", "No flights closed yet today.")}
  </div>
</div>
`;
}

function summaryHTML(): string {
  return `
    <div class="owner-summary" style="margin-bottom: 22px">
      <template x-if="$store.board.role === 'Owner'">
        <div style="display: contents">
          <div class="metric">
            <div class="lbl">Fleet hours today</div>
            <div class="val" x-text="fleetHoursToday"></div>
            <div class="sub">closed flights</div>
          </div>
          <div class="metric">
            <div class="lbl">Utilization</div>
            <div class="val"><span x-text="fleetUtilization"></span><span style="font-size: 13px; color: var(--ink-500)">%</span></div>
            <div class="sub">flown vs operating window</div>
          </div>
          <div class="metric">
            <div class="lbl">Airborne now</div>
            <div class="val" style="color: var(--cyan-700)" x-text="airborneCount"></div>
            <div class="sub">tracking ETA</div>
          </div>
          <div class="metric">
            <div class="lbl">Not ready</div>
            <div class="val" style="color: var(--warn-700)" x-text="blockedCount"></div>
            <div class="sub down">unresolved warnings</div>
          </div>
        </div>
      </template>
      <template x-if="$store.board.role !== 'Owner'">
        <div style="display: contents">
          <div class="metric">
            <div class="lbl">Total today</div>
            <div class="val" x-text="totalCount"></div>
            <div class="sub">all flights &amp; ground</div>
          </div>
          <div class="metric">
            <div class="lbl">Ready to taxi</div>
            <div class="val" style="color: var(--ok-700)" x-text="readyCount"></div>
            <div class="sub up">cleared, no blockers</div>
          </div>
          <div class="metric">
            <div class="lbl">Airborne now</div>
            <div class="val" style="color: var(--cyan-700)" x-text="airborneCount"></div>
            <div class="sub">tracking ETA</div>
          </div>
          <div class="metric">
            <div class="lbl">Not ready</div>
            <div class="val" style="color: var(--warn-700)" x-text="blockedCount"></div>
            <div class="sub down">unresolved warnings</div>
          </div>
        </div>
      </template>
    </div>
  `;
}

function columnHTML(cls: string, title: string, cardsKey: string, emptyText: string): string {
  return `
    <div class="dp-col ${cls}">
      <div class="dp-col-h">
        <h2>${title}</h2>
        <span class="count" x-text="${cardsKey}.length"></span>
      </div>
      <div class="dp-col-body">
        <template x-if="${cardsKey}.length === 0">
          <div class="empty-col">${emptyText}</div>
        </template>
        <template x-for="b in ${cardsKey}" :key="b.id">
          ${cardHTML()}
        </template>
      </div>
    </div>
  `;
}

function cardHTML(): string {
  return `
    <div :class="cardClass(b)"
      role="button" tabindex="0"
      :aria-label="\`Open dispatch \${aircraftLabel(b.aircraftId)} \${b.start} to \${b.end}\`"
      @click="$store.ui.openView(b)"
      @keydown.enter.prevent="$store.ui.openView(b)"
      @keydown.space.prevent="$store.ui.openView(b)">
      <div class="dp-card-top">
        <span class="mono tail" x-text="aircraftLabel(b.aircraftId)"></span>
        <span class="chip" :class="b.status">
          <span class="chip-dot"></span><span x-text="statusLabel(b)"></span>
        </span>
        <template x-if="hasWarn(b) && !isReady(b) && b.status === 'scheduled'">
          <span class="chip warning" style="margin-left: auto">
            <span class="chip-dot"></span>not ready
          </span>
        </template>
        <template x-if="isReady(b) && b.status === 'ready'">
          <span class="chip ready" style="margin-left: auto">
            <span class="chip-dot"></span>cleared
          </span>
        </template>
      </div>
      <div class="dp-times mono">
        <span><span class="dim">ETD</span> <span x-text="b.start"></span></span>
        <span><span class="dim">ETA</span> <span x-text="b.end"></span></span>
      </div>
      <div class="dp-card-body">
        <div>
          <div class="lbl">Lesson</div>
          <div x-text="lessonName(b.lessonId)"></div>
        </div>
        <div>
          <div class="lbl" x-text="b.aircraftId ? 'Aircraft' : 'Room'"></div>
          <div class="mono" x-text="aircraftModel(b.aircraftId)"></div>
        </div>
        <div>
          <div class="lbl">Student</div>
          <div x-text="userName(b.studentId)"></div>
        </div>
        <div>
          <div class="lbl">Instructor</div>
          <div x-text="userName(b.instructorId) || 'solo'" :class="!b.instructorId ? 'dim' : ''"></div>
        </div>
      </div>
      <template x-if="hasWarn(b) && !isReady(b)">
        <div class="dp-warn-line">
          ${icon("warn", 12)}
          <span x-text="warnSummary(b)"></span>
        </div>
      </template>
      <template x-if="nextLabel(b) && canAdvance">
        <div class="dp-card-foot">
          <button class="btn btn-sm" @click.stop="$store.ui.openView(b)">Detail</button>
          <button class="btn btn-primary btn-sm" style="margin-left: auto"
            @click.stop="advance(b)">
            <span x-text="nextLabel(b)"></span> ${icon("arrowR", 11)}
          </button>
        </div>
      </template>
    </div>
  `;
}
